<kendo-tabstrip #tabstrip>
    <kendo-tabstrip-tab title="{{ 'COMMUNITY-SERVICES-SEARCH' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
            <form novalidate [formGroup]="searchForm" class="k-form" *ngIf="loaded">
                <kendo-splitter #splitter orientation="vertical" (layoutChange)="updateSplitterBar()">
                    <kendo-splitter-pane [collapsible]="true" min="90px" [(size)]="paneSize"
                        style="overflow-x:hidden;padding-left:4px;padding-right:4px;padding-bottom:20px">
                        <div class="row">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'FILTER-NAME' | translate}}
                                    </span>
                                    <kendo-multicolumncombobox class="w-100" formControlName="filter"
                                        [data]="filtersFiltered" [textField]="'name'" [valueField]="'id'"
                                        [listHeight]="400" [filterable]="true" (filterChange)="filterFilters($event)"
                                        [placeholder]="'TYPE-OR-SELECT' | translate">
                                        <kendo-combobox-column field="name" title="{{'NAME' | translate}}" [width]="80">
                                            <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
                                                <span class="pl-3">{{ dataItem.name }}</span>
                                            </ng-template>
                                        </kendo-combobox-column>
                                        <kendo-combobox-column title="{{'ACTION' | translate}}" [width]="20">
                                            <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
                                                <div class="text-center">
                                                    <i *ngIf="dataItem.category === 'CommunityService' || (dataItem.category === 'CommunityServiceSystem' && allowSystemFilters)"
                                                        class="fas fa-trash-alt fa-lg"
                                                        title="{{ 'DELETE' | translate }}"
                                                        (click)="deleteFilter(dataItem['id'])">
                                                    </i>
                                                </div>
                                            </ng-template>
                                        </kendo-combobox-column>
                                    </kendo-multicolumncombobox>
                                </label>
                            </div>
                            <!--Clear and Save filter-->
                            <div class="col-8" *ngIf="showFilterBtnActions" style="margin:auto;padding-top: 18px;">
                                <button #saveFilterControl *ngIf="saveFilterVisible" class="mr-2" kendoButton
                                    (blur)="saveFilterButtonFocused=false" (focus)="saveFilterButtonFocused=true"
                                    (click)="openFilterScreen($event)">{{ 'SAVE-FILTER' | translate }}
                                </button>
                                <i class="far fa-fw fa-times-circle fa-delete-custom"
                                    title="{{'SEARCH-CLEAR-ALL' | translate}}" (click)="clearFilters()"
                                    style="font-size:20pt;position:relative;" role="button"
                                    attr.aria-label="{{'SEARCH-CLEAR-ALL' | translate}}"
                                    [ngStyle]="{'top': saveFilterVisible ? '7px' : '0'}" tabindex="0"
                                    (keydown.enter)="clearFilters()" (keydown.space)="clearFilters()">
                                </i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4" *ngIf="isSearchable('NAME')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'SERVICE-NAME' | translate}}
                                    </span>
                                    <input id="name" kendoTextBox formControlName="name" maxlength="500" />
                                </label>
                            </div>
                            <div class="col-4" *ngIf="isSearchable('SERVICE_CATEGORY')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'COMMUNITY-SERVICE-CATEGORIES' | translate}}
                                    </span>
                                    <kendo-multiselect #serviceCategoryControl id="categories"
                                        [data]="categoriesFiltered" class="w-100" formControlName="categories"
                                        [textField]="'name'" [filterable]="true" [valueField]="'id'"
                                        [itemDisabled]="itemDisabled" (filterChange)="filterCategories($event)"
                                        (valueChange)="valueChange($event,'previousServiceCategories')"
                                        attr.aria-label="{{'COMMUNITY-SERVICE-CATEGORIES' | translate}}"
                                        (close)="searchTerm=''" [autoClose]="false" [virtual]="virtualLookups">
                                        <ng-template kendoMultiSelectGroupTemplate let-dataItem>
                                            <input id="category-{{dataItem}}" type="checkbox" #categoryCheckbox
                                                (click)="groupCategoryClick(dataItem, $event)" kendoCheckBox
                                                [checked]="isServiceCategoryGroupChecked(dataItem)" /><span
                                                class="ml-1 pointer"
                                                (click)="categoryCheckbox.click()">{{dataItem}}</span>
                                        </ng-template>
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <div class="ml-2 pl-3">
                                                <input type="checkbox"
                                                    [checked]="isServiceCategoryFilterSelected(dataItem)"
                                                    kendoCheckBox />
                                                <label class="k-checkbox-label"
                                                    innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                                </label>
                                            </div>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-4" *ngIf="allResourceStatuses.length > 0 && isSearchable('STATUS')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'RESOURCE-STATUS' | translate}}
                                    </span>
                                    <kendo-multiselect id="resourceStatuses" [data]="resourceStatusesFiltered"
                                        attr.aria-label="{{'RESOURCE-STATUS' | translate}}" class="w-100"
                                        style="max-height: 170px;overflow: auto;" formControlName="resourceStatuses"
                                        [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterResourceStatuses($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousResourceStatuses')"
                                        [autoClose]="true" [virtual]="virtualLookups">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4" *ngIf="isSearchable('ORGANIZATION')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ORGANIZATIONS' | translate}}
                                    </span>
                                    <kendo-multiselect id="organizations" [data]="organizationsFiltered" class="w-100"
                                        style="max-height: 170px;overflow: auto;" formControlName="organizations"
                                        [textField]="'name'" [filterable]="true" [valueField]="'id'"
                                        attr.aria-label="{{'ORGANIZATIONS' | translate}}" [itemDisabled]="itemDisabled"
                                        (filterChange)="filterOrganizations($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousOrganizations')" [autoClose]="true"
                                        [virtual]="virtualLookups">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-4" *ngIf="isSearchable('SUBMITTING_ORGANIZATION')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'SUBMITTING-ORGANIZATION' | translate}}
                                    </span>
                                    <kendo-multiselect id="submittingOrganizations"
                                        [data]="submittingOrganizationsFiltered" class="w-100"
                                        style="max-height: 170px;overflow: auto;"
                                        attr.aria-label="{{'SUBMITTING-ORGANIZATION' | translate}}"
                                        formControlName="submittingOrganizations" [textField]="'name'"
                                        [filterable]="true" [valueField]="'id'" [itemDisabled]="itemDisabled"
                                        (filterChange)="filterSubmittingOrganizations($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousSubmittingOrganizations')"
                                        [autoClose]="true" [virtual]="virtualLookups">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-4" *ngIf="allTaxonomies.length > 0 && isSearchable('TAXONOMIES')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'TAXONOMIES' | translate}}
                                    </span>
                                    <kendo-multiselect id="taxonomies" [data]="taxonomiesFiltered" class="w-100"
                                        style="max-height: 170px;overflow: auto;" formControlName="taxonomies"
                                        [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterTaxonomies($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousTaxonomies')" [autoClose]="true"
                                        [virtual]="virtualLookups" attr.aria-label="{{'TAXONOMIES' | translate}}">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4" *ngIf="isSearchable('AREAS_SERVED_CITIES')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'AREAS-SERVED-CITIES' | translate}}
                                    </span>
                                    <kendo-multiselect id="servedCities" [data]="servedCitiesFiltered" class="w-100"
                                        style="max-height: 170px;overflow: auto;" formControlName="servedCities"
                                        [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterServedCities($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousCitiesServed')" [autoClose]="true"
                                        [virtual]="virtualLookups"
                                        attr.aria-label="{{'AREAS-SERVED-CITIES' | translate}}">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-4" *ngIf="isSearchable('AREAS_SERVED_COUNTIES')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'AREAS-SERVED-COUNTIES' | translate}}
                                    </span>
                                    <kendo-multiselect id="servedCounties" [data]="servedCountiesFiltered" class="w-100"
                                        style="max-height: 170px;overflow: auto;" formControlName="servedCounties"
                                        [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterServedCounties($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousCountiesServed')" [autoClose]="true"
                                        [virtual]="virtualLookups"
                                        attr.aria-label="{{'AREAS-SERVED-COUNTIES' | translate}}">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-4" *ngIf="isSearchable('AREAS_SERVED_ZIPCODES')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'AREAS-SERVED-ZIPCODES' | translate}}
                                    </span>
                                    <kendo-multiselect id="servedZipCodes" [data]="servedZipCodesFiltered" class="w-100"
                                        style="max-height: 170px;overflow: auto;" formControlName="servedZipCodes"
                                        [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterServedZipCodes($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousZipCodesServed')" [autoClose]="true"
                                        [virtual]="virtualLookups"
                                        attr.aria-label="{{'AREAS-SERVED-ZIPCODES' | translate}}">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-4" *ngIf="isSearchable('LANGUAGES')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'LANGUAGES' | translate}}
                                    </span>
                                    <kendo-multiselect id="languages" [data]="languagesFiltered" class="w-100"
                                        style="max-height: 170px;overflow: auto;" formControlName="languages"
                                        [textField]="'displayName'" [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterLanguages($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousLanguages')" [autoClose]="true"
                                        [virtual]="virtualLookups" role="combobox"
                                        attr.aria-label="{{'LANGUAGES' | translate}}" aria-expanded="false"
                                        aria-controls=".k-list-ul">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-4" *ngIf="isSearchable('TARGETED_DEMOGRAPHICS')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'TARGETED-DEMOGRAPHICS' | translate}}
                                    </span>
                                    <kendo-multiselect id="targetedDemographics" [data]="targetedDemographicsFiltered"
                                        class="w-100" style="max-height: 170px;overflow: auto;"
                                        formControlName="targetedDemographics" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        attr.aria-label="{{'TARGETED-DEMOGRAPHICS' | translate}}"
                                        (filterChange)="filterTargetedDemographics($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousTargetedDemographics')"
                                        [autoClose]="true" [virtual]="virtualLookups">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-4" *ngIf="isSearchable('TARGETED_POPULATIONS')">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'TARGETED-POPULATIONS' | translate}}
                                    </span>
                                    <kendo-multiselect id="targetedPopulations" [data]="targetedPopulationsFiltered"
                                        class="w-100" style="max-height: 170px;overflow: auto;"
                                        formControlName="targetedPopulations" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        attr.aria-label="{{'TARGETED-POPULATIONS' | translate}}"
                                        (filterChange)="filterTargetedPopulations($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousTargetedPopulations')"
                                        [autoClose]="true" [virtual]="virtualLookups">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-4"
                                *ngIf="isSearchable('ENHANCED_SERVICE_ELIGIBILITY') && enhancedServicesFiltered.length > 0">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ENHANCED-SERVICES-OFFERED' | translate}}
                                    </span>
                                    <kendo-multiselect id="enhancedServices" [data]="enhancedServicesFiltered"
                                        class="w-100" style="max-height: 170px;overflow: auto;"
                                        formControlName="enhancedServices" [textField]="'displayName'"
                                        [filterable]="true" [valueField]="'id'"
                                        attr.aria-label="{{'ENHANCED-SERVICES-OFFERED' | translate}}"
                                        (filterChange)="filterEnhancedServices($event)" (close)="searchTerm=''"
                                        (valueChange)="valueChange($event,'previousEnhancedServices')"
                                        [autoClose]="true" [virtual]="virtualLookups">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                            <div class="col-4 my-auto pt-3" *ngIf="isSearchable('ACCEPTING_NEW_PATIENTS')">
                                <label class="k-text-uppercase dark k-checkbox-label">
                                    {{'ACCEPTING-NEW-PATIENTS' | translate:patientLabel }}?
                                    <input id="acceptingNewPatients" type="checkbox" kendoCheckBox
                                        formControlName="acceptingNewPatients"
                                        [indeterminate]="acceptingNewPatients.value === null" />
                                </label>
                            </div>
                            <div class="col-4 my-auto pt-3" *ngIf="isSearchable('ACCEPTING_SELF_REFERRALS')">
                                <label class="k-text-uppercase dark k-checkbox-label">
                                    {{'ACCEPTING-SELF-REFERRALS' | translate }}?
                                    <input id="acceptingSelfReferrals" type="checkbox" kendoCheckBox
                                        formControlName="acceptingSelfReferrals"
                                        [indeterminate]="acceptingSelfReferrals.value === null" />
                                </label>
                            </div>
                            <div class="col-4 my-auto pt-3" *ngIf="isSearchable('ABLE_TO_CONDUCT_SCREENINGS')">
                                <label class="k-text-uppercase dark k-checkbox-label">
                                    {{'ABLE-TO-CONDUCT-SCREENINGS' | translate }}?
                                    <input id="ableToConductScreenings" type="checkbox" kendoCheckBox
                                        formControlName="ableToConductScreenings"
                                        [indeterminate]="ableToConductScreenings.value === null" />
                                </label>
                            </div>
                            <div class="col-4 my-auto pt-3" *ngIf="isSearchable('INFORMATIONAL_ONLY')">
                                <label class="k-text-uppercase dark k-checkbox-label">
                                    {{'INFORMATIONAL-ONLY' | translate }}?
                                    <input id="informationalOnly" type="checkbox" kendoCheckBox
                                        formControlName="informationalOnly"
                                        [indeterminate]="informationalOnly.value === null" />
                                </label>
                            </div>
                        </div>
                        <div class="row" *ngIf="searchByDistanceEnabled">
                            <div class="col-6">
                                <div class="mt-3">
                                    <label class="k-checkbox-label k-text-uppercase dark">{{'DISTANCE-FILTER' |
                                        translate}}
                                        <input type="checkbox" id="distanceFilter" [formControl]="filterByDistance"
                                            kendoCheckBox />
                                    </label>
                                    <span *ngIf="filterByDistance.value">({{formatMaxDistanceLabel(maxDistance.value)}})
                                    </span>
                                </div>
                                <div *ngIf="filterByDistance.value">
                                    <kendo-slider [tickPlacement]="'none'" formControlName="maxDistance" [min]="1"
                                        [max]="maxDistanceDefault" [smallStep]="1" [showButtons]="false"
                                        class="w-75 ml-3">
                                    </kendo-slider>
                                </div>
                            </div>
                        </div>
                    </kendo-splitter-pane>
                    <kendo-splitter-pane style="overflow-x:hidden">
                        <div class="row">
                            <div class="col-12 mt-3">
                                <button *ngIf="pinnedResourcesEnabled && memberId > 0"
                                    [disabled]="selectedResourcesCount === 0" kendoButton class="ml-2 float-right"
                                    (click)="pinServices()">{{ 'PIN' | translate }}<i class="fal fa-thumbtack"></i><span
                                        *ngIf="selectedResourcesCount > 0"
                                        class="ml-1">({{selectedResourcesCount}})</span>
                                </button>
                                <button *ngIf="communityPortalEnabled" [disabled]="selectedResourcesCount === 0"
                                    kendoButton class="ml-2 float-right" (click)="smsServices()">{{ 'SMS' | translate
                                    }}<i class="fal fa-mobile"></i><span *ngIf="selectedResourcesCount > 0"
                                        class="ml-1">({{selectedResourcesCount}})</span>
                                </button>
                                <button [disabled]="selectedResourcesCount === 0" kendoButton class="ml-2 float-right"
                                    (click)="emailServices()">{{ 'EMAIL' | translate }}<i
                                        class="fal fa-envelope"></i><span *ngIf="selectedResourcesCount> 0"
                                        class="ml-2">({{selectedResourcesCount}})</span>
                                </button>
                                <button [disabled]="selectedResourcesCount === 0" kendoButton class="ml-2 float-right"
                                    (click)="printServices()">{{ 'PRINT' | translate }}<i class="fal fa-print"></i><span
                                        *ngIf="selectedResourcesCount > 0"
                                        class="ml-1">({{selectedResourcesCount}})</span>
                                </button>
                                <i *ngIf="(selectedResourcesCount > 0) || (selectedReferralsCount > 0)"
                                    class="far fa-fw fa-times-circle fa-delete-custom float-right mr-2"
                                    title="{{'SEARCH-CLEAR-ALL' | translate}}" (click)="clearAllSelected()"
                                    style="font-size:20pt;" tabindex="0" (keydown.enter)="clearAllSelected()"
                                    (keydown.space)="clearAllSelected()">
                                </i>
                            </div>
                        </div>
                        <kendo-grid #grid [data]="gridView" [pageable]="{ buttonCount: 5, pageSizes: pageSizes}"
                            [pageSize]="state.take" [skip]="state.skip" [loading]="loading" [sort]="state.sort"
                            [filter]="state.filter" [sortable]="true" [filterable]="false" [columnMenu]="enableAdvanced"
                            [resizable]="true" [reorderable]="enableAdvanced" [selectable]="{  mode: 'multiple' }"
                            [navigable]="true" (dataStateChange)="dataStateChange($event)"
                            (pageChange)="pageChange($event)" (columnVisibilityChange)="onVisibilityChange($event)"
                            (columnResize)="onResize($event)" (columnReorder)="onReorder($event)" [style.height.%]="100"
                            class="mt-3">
                            <kendo-grid-messages noRecords="{{ 'NO-COMMUNITY-PROVIDER' | translate }}">
                            </kendo-grid-messages>
                            <kendo-grid-column title="{{ 'SELECT-RESOURCE' | translate }}" [width]="40"
                                [field]="selectedResource">
                                <ng-template kendoGridCellTemplate let-dataItem let-idx="rowIndex">
                                    <div class="text-center">
                                        <input *ngIf="!loading" type="checkbox" id="selectedRow1{{ idx }}"
                                            name="selectedRow1{{ idx }}" [(ngModel)]="dataItem.selectedResource"
                                            [ngModelOptions]="{standalone: true}"
                                            (change)="selectionChange($event,dataItem,selectedResourcesIds,false)"
                                            kendoCheckBox />
                                    </div>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title=" {{ 'CONSENT-TO-REFER' | translate }}" [width]="40"
                                *ngIf="memberId > 0" [field]="selectedReferral">
                                <ng-template kendoGridCellTemplate let-dataItem let-idx="rowIndex">
                                    <div class="text-center">
                                        <input *ngIf="!loading" type="checkbox" id="selectedRow2{{ idx }}"
                                            name="selectedRow2{{ idx }}" [(ngModel)]="dataItem.selectedReferral"
                                            [ngModelOptions]="{standalone: true}"
                                            (change)="selectionChange($event,dataItem,consentToReferIds,true)"
                                            kendoCheckBox />
                                    </div>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column *ngFor="let col of columnsConfig" [field]="col.field" [title]="col.title"
                                [width]="col.width" [filterable]="false" [sortable]="col.sortable"
                                [hidden]="col.hidden !== undefined ? col.hidden : false"
                                [class]="col.class !== undefined ? col.class : ''">
                                <!--Yes/No template-->
                                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'acceptingNewPatients' || col.field === 'acceptingSelfReferrals' || 
                                    col.field === 'ableToConductScreenings' || col.field === 'informationalOnly'">
                                    <span *ngIf="dataItem[col.field]">{{ 'YES' | translate }}</span>
                                    <span *ngIf="!dataItem[col.field] && dataItem[col.field] !== null">{{ 'NO' |
                                        translate }}
                                    </span>
                                </ng-template>
                                <!--Potential long properties template and show title on mouse over-->
                                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'languagesName' || col.field === 'taxonomiesName' || 
                                col.field === 'eligibility' || col.field === 'cost' || col.field === 'alias' || col.field === 'alertDescription' ||
                                col.field === 'enhancedServicesName'">
                                    <span title="{{dataItem[col.field]}}">{{dataItem[col.field]}}</span>
                                </ng-template>
                                <!--Distance template-->
                                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'distance'">
                                    <div *ngIf="dataItem.distance" class="text-center">
                                        {{dataItem.distance | number : '1.2-2'}}
                                        {{formatDistanceLabel(dataItem.distance)}}
                                    </div>
                                    <div class="text-center" *ngIf="!dataItem.distance">{{ 'NA' | translate }}</div>
                                </ng-template>
                            </kendo-grid-column>
                            <!--Program details information below-->
                            <ng-template kendoGridDetailTemplate let-dataItem tabindex="0" class="keyboard-accessible">
                                <app-community-service-info-detail [service]="dataItem" [i]="0" [servicesCount]="1">
                                </app-community-service-info-detail>
                            </ng-template>
                        </kendo-grid>
                    </kendo-splitter-pane>
                </kendo-splitter>
            </form>
        </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>

<!--Save Filter dialog-->
<app-save-filter [dialogOpened]="filterDialogOpened" [filterCategory]="'CommunityService'" [filterState]="state"
    (cancelling)="filterDialogOpened=false;" (save)="filterSaved($event)" [filter]="filterSelected"
    [showSystemFilter]="true" [systemFilterEnabled]="allowSystemFilters">
</app-save-filter>

<!--Show Service Info-->
<app-community-service-info *ngIf="servicesOpened" [memberId]="memberId" [programIds]="selectedResourcesIds"
    (cancelling)="closeServicesInfo();" [isPrint]="isPrint" [isEmail]="isEmail" [isSMS]="isSMS"
    [contactEmail]="selectedEmailAddress" [contactSMS]="selectedPhoneNumber">
</app-community-service-info>

<!--Confirm Email when no patient in context-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="emailConfirmationOpened || smsConfirmationOpened"
    (close)="emailConfirmationOpened=false;smsConfirmationOpened=false;" [minWidth]="250" [width]="450">
    <form [formGroup]="emailForm" class="k-form">
        <div class="row">
            <div class="col-12">
                <label class="k-form-field" *ngIf="emailConfirmationOpened" for="email">
                    <span class="k-text-uppercase dark">
                        <i class="fas fa-envelope fa-fw"></i> {{'EMAIL' | translate}} *
                    </span>
                    <input id="email" class="w-100" kendoTextBox formControlName="email" email />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="email.hasError('required') && email.touched">
                        {{'REQUIRED-EMAIL' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="email.invalid && email.touched && email.value">
                        {{'WRONG-EMAIL-FORMAT' | translate}}
                    </div>
                </label>
                <label class="k-form-field" *ngIf="smsConfirmationOpened" for="sms">
                    <span class="k-text-uppercase dark">
                        <i class="fas fa-mobile fa-fw"></i> {{'SMS' | translate}} *
                    </span>
                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="sms" formControlName="sms" class="w-100">
                    </kendo-maskedtextbox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="sms.hasError('required') && sms.touched">
                        {{'REQUIRED-PHONE' | translate}}
                    </div>
                </label>
            </div>
        </div>
    </form>
    <kendo-dialog-actions>
        <button kendoButton (click)="emailConfirmationOpened=false;smsConfirmationOpened=false;">{{ 'CANCEL' |
            translate }}
        </button>
        <button appPreventClick kendoButton (click)="emailConfirmationOpened ? onSendEmail() : onSendSMS();"
            [primary]="true" [disabled]="!emailForm.valid">
            {{ 'SEND' | translate }}<i class="fal fa-paper-plane"></i>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>